import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'

export const commonsStyles = css`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.pureBlack};
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: ${({ theme }) => theme.colors.pureBlack};
  text-decoration-thickness: 2px;
  text-underline-position: under;
  padding-bottom: 0.1rem;

  ${({ theme }) => theme.textStyles.text_medium_16}

  @media ${mq(sizes.desktop)} {
    padding-bottom: 0.2rem;
    ${({ theme }) => theme.textStyles.text_medium_18}
  }
`

export const Link = styled.a`
  ${commonsStyles}
`

export const Button = styled.button`
  ${commonsStyles}

  background-color: transparent;

  @media ${mq(sizes.desktop)} {
    &:hover {
      color: ${({ theme }) => theme.colors.redMojo};
      text-decoration-color: ${({ theme }) => theme.colors.redMojo};
    }
  }
`

export const Span = styled.span`
  & br {
    display: none;
  }
`
